import React, { useState } from "react";
import "../Header/Header.css";
import {  Link, NavLink } from "react-router-dom";
import { IoMdMenu, IoMdCloseCircle } from "react-icons/io";

function Header() {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => () => {
    setOpen(!open);
  };

  return (
    <>
      <div className="header">
        <div>
          <Link to="/template2/" className="header-div1"><h1>Medisol Lab</h1></Link>
          {/* <p className="slogan">Breather for Life</p> */}
        </div>

        <div className="hide">
        <div className={open ? "header-div2" : "close"}  onClick={toggleDrawer(false)}>
          <NavLink to="/template2/" className="header-menu">
            Home
          </NavLink>
          <NavLink to="/template2/services" className="header-menu">
            Services
          </NavLink>
          <NavLink to="/template2/contactus" className="header-menu">
            Contact
          </NavLink>
        </div>
        
        {!open ? (
          <IoMdMenu className="header-bars-icon" onClick={toggleDrawer(true)}/>
        ) : ( 
          <IoMdCloseCircle className="header-bars-icon" onClick={toggleDrawer(false)}/>
        )} 
        </div>
        <div className="menu-max">
          {/* <Nav> */}
          <NavLink to="/template2/" className="header-menu">
            Home
            {/* <hr className="header-underline"/> */}
          </NavLink>
          <NavLink to="/template2/services" className="header-menu">
            Services
            {/* <hr className="header-underline"/> */}
          </NavLink>
          <NavLink to="/template2/contactus" className="header-menu">
            Contact
            {/* <hr className="header-underline"/> */}
          </NavLink>
          {/* </Nav> */}
          
        </div>

      </div>
    </>
  );
}
export default Header;
